module.exports = __webpack_public_path__ + "static/img/FuXiang_Banner.3bb609db.jpg";